import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Clock, Headset, Mail } from "lucide-react";
import { supportContact } from "../lib/api";

// Emergency page: who to contact at HearthVault and how quickly they answer.
export const HelpContactCard = () => {
  const { data } = useQuery({ queryKey: ["support-contact"], queryFn: supportContact });
  if (!data?.email) return null;
  return (
    <section className="rounded-2xl border border-border bg-card p-5 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="help-contact-card">
      <span className="h-10 w-10 rounded-xl bg-primary/10 text-primary grid place-items-center shrink-0"><Headset className="h-5 w-5" /></span>
      <div className="flex-1 min-w-0">
        <h2 className="font-serif text-xl">Need help from a person?</h2>
        <p className="text-sm text-muted-foreground mt-0.5">Email the HearthVault team about access, codes or anything here that isn't working.</p>
        <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-sm">
          <a href={`mailto:${data.email}`} className="inline-flex items-center gap-1.5 text-primary hover:underline" data-testid="help-contact-email"><Mail className="h-4 w-4" /> {data.email}</a>
          <span className="inline-flex items-center gap-1.5 text-muted-foreground" data-testid="help-contact-reply-time"><Clock className="h-4 w-4" /> We reply {data.reply_time.toLowerCase()}</span>
        </div>
        {data.notice?.active && <p className="mt-2 text-sm rounded-lg bg-amber-50 text-amber-900 dark:bg-amber-900/30 dark:text-amber-200 px-3 py-2" data-testid="help-contact-notice">{data.notice.message}</p>}
      </div>
      <Link to="/support" className="inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground px-4 py-2 text-sm hover:opacity-90 transition-opacity shrink-0" data-testid="help-contact-request-btn">Send a request</Link>
    </section>
  );
};
